export default window.Gecko;
